import React from "react";
import Container from "react-bootstrap/esm/Container";
import { Row, Col } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Whatsappicon from "./components/Whatsappicon";

const Home = () => {
  document.title = "WSSL | World Standards Scientific LLP";

  return (
    <>
	<br/>
	<Whatsappicon />
      <Container>
        <Row>
          <Col xs={12} md={8} lg={6}>
            <div style={{ width: "100%" }} className="m-3">
              <Card>
                <Card.Body >
                  <h2 style={{color:"#4aa439"}} className="text-center">ABOUT US </h2>
                  <Card.Subtitle className="mb-2 "></Card.Subtitle>
                  <Card.Text >
				  World Standards Scientific LLP (WSSL) Is The World's Most Leading Consulting Firm, A
				  Reliable Service Provider Occupied In Offering Product Testing Laboratory & ISI
				  /BIS Certification, Food Testing Laboratory & Food License Certification, Training,
				  Regulatory Compliances, Indian Standard Assessment Like ISI Certification Services,
				  Foreign Manufacturer Certification, NABL Accreditation Consultancy, Indian BIS
				  And CRS Scheme For Electronics & It Goods, And Many More. As Of Now, Products
				  Certifications & Compliances Is Being Catered By 'World Standards Scientific LLP
				  The Offering Range Of Service Is Rendered In Obedience With The Quality
				  Constraints By Our Competent Experts Who Hold A Rich Understanding Of The
				  Particular Fields.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
		  <br/>
          <Col xs={12} md={8} lg={6}>
            <div className="m-3 shado mt-5">
              <Image
                src="./Images/laboratory-flooring.jpg"
                style={{ width: "100%",height:"65vh" }}
             className="rounded-2" />
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
      
        <section >
          <h2 style={{ textAlign: "center", background: "lightblue" }}>Let's first look at what is BIS Certification?</h2>
          <p >
            BIS Certification: Under the BIS Act, 1986, the government of India
            established the National Indian certification body BIS i.e. Bureau
            of Indian Standards under the Indian Ministry of Consumer
            Protection, Food and Public Distribution. Bureau of Indian Standards
            is the largest Indian certification body and having an increasingly
            important role in managing, grading, and standardizing the quality
            standards of several consumer products. In this role, BIS as an
            agency is responsible for a number of key certifications in the
            Indian market.
          </p>
          <p >
            The Bureau of Indian Standards issues BIS Certificate in India to
            the manufacturers of various products to assure product quality,
            consumers safety, and reliability of the customers. BIS gives the
            BIS certificate to the companies after confirming the standards of
            their products. Additionally, this process conducted by Bureau of
            India Standards helps the companies to put up a reputed brand image
            of their product in the industry. From all these years, the BIS has
            become the second name of quality and genuineness. After BIS
            Certification the manufacturers gets eligible to use the standard
            mark i.e, ISI mark symbol on their BIS certified products.
          </p>
        </section>
        <section>
		<br/>
          <h2 style={{ textAlign: "center", background: "lightblue" }}>Why BIS Certificate?</h2>
          <p >
        
            Anything a person buys from food to cars, clothes to electronics,
            branded to unnamed products there is always a question that wanders
            in one's mind that how to know if he/she can trust the product or
            the company with the name product comes from. Are there any
            parameters by which one can estimate the luxury, quality, or grade
            of the product about to be bought, and if there is some kind of
            parameters then who decides these parameters? How is your customer
            going to know that they can trust your brand and its products? This
            is where BIS Certification comes into play.
          </p>
          <p>
            
            BIS Certification in India is considered to be a mark of trust for
            the buyers. A BIS Certificate from the Bureau of Indian Standards
            allows the manufacturers to assure the consumers about product
            quality, consumer’s safety, and trustworthiness. Basically BIS
            Certification Scheme is a voluntary scheme, however some products
            are covered under the mandatory certification scheme of BIS.
          </p>
        </section>
        <br />
        <section>
          <h2 style={{ textAlign: "center", background: "lightblue" }}>What is ISI Mark?</h2>
          <p>
            
            ISI stands for Indian Standards Institute, the National Standards
            body renamed Bureau of Indian Standards in 1987. The ISI mark is the
            standard mark provided to the manufacturers by the Bureau of Indian
            Standards for various products. The ISI Mark has been considered as
            a mark of purity, safety and trust since 1955. The ISI mark has
            served as a conformity mark for industrial items. It ensures that
            the product complies with an Indian standard (IS) established by
            India's national standards organization, the Bureau of Indian
            Standards (BIS).
          </p>
          <p>
            ISI Certification is the process of obtaining the ISI mark for any
            product that complies the Indian Standards. Various electrical
            appliances require mandatory ISI mark, such as Electric Iron, Room
            Heaters, Room AC, Electric Stoves, Freezers, Electric cables, and
            other products like UPVC Pipes, Rubber & Leather Footwears,
            Composite Cements, various acids, etc.
          </p>
        </section>
        <br />

        <section>
          <h2 style={{ textAlign: "center", background: "lightblue" }}>Basic Requirements for ISI Certification:</h2>
          <p>
            
            The following are the basic requirements for obtaining a BIS
            license, as listed below.
          </p>
          <p>
            • The product must meet the Indian Standard Specification criteria.
          </p>
          <p>
            
		  • BIS license is only given to the factory (manufacturer of finished
            products), not to the Distributor/Retailer.
          </p>
          <p>
		  • If a manufacturer has multiple factories, each of which is located
            at a distance geographical address, the business must file a
            separate application for each product and factory location.
          </p>
          <p>
		  • The laboratory should be fully equipped with product testing
            equipment as well as qualified quality control personnel to test the
            product in accordance with the applicable ISI.
          </p>
          <p>
		  • All production machinery and testing facilities should be located
            on the factory premises as per ISI norms.
          </p>
        </section>
		<br/>

		<section>
		<h2 style={{ textAlign: "center", background: "lightblue" }}>Benefits of ISI Mark Certification
		</h2>
		<p>With BIS ISI Certificates, companies and their products simply unlock the following motives:

		</p>
		<p>• ISI Certificate allows the manufacturers uninterrupted manufacturing and selling of their products in every part of India.

		</p>
		<p> • An ISI certificate allows the manufacturers to manufacture products which are in the mandatory certification scheme. Manufacturing these products without an ISI certificate could result in a substantial fine, imprisonment or both.

		</p>
		<p>• ISI Mark on any product ensures consumer's safety and health and develops trust.

		</p>
		<p>• An ISI-certified product ensures high quality and consumer satisfaction, which increases revenue.

		</p>
		<p>Do you know that BIS ISI Mark Certificate is mandatory in India for more than 150 products? Even though it is voluntary to get BIS, the BIS made it compulsory to attain the certificate on certain products to make sure the safety of the consumers from counterfeits and fake merchandise.

		</p>
		</section>
		<section>
		<h2 style={{ textAlign: "center", background: "lightblue" }}>List of Products Under ISI Certification:
		</h2>
		<div className="row">
		<div className="col">
		<p>- Food-related products
		</p>
		<p>- Glass & Glassware</p>
		<p>- Cylinders and regulators</p>
					<p>- Building Materials</p>
					<p>- Primary Batteries</p>
					<p>- Rubber</p>
					<p>- Oil pressure stoves</p>
					<p>- Wire & Cables</p>
					<p>- Medical equipment</p>
					<p>- Shoes & Leather Products</p>
					<p>- Cement</p>
					
		</div>
		<div className="col">
		<p>- Automotive</p>
		<p>- Capacitors</p>
		<p>- Aluminum</p>
		<p>- Chemicals and fertilizers</p>
		<p>- Wheel Rim & Valves</p>
		<p>- Household electrical goods </p>
		<p>- Steel Products</p>
		<p>- Electric motors and transformers</p>
		</div>
		</div>
		
		</section>
		<br/>
		<div className="d-flex justify-content-center">
		<div style={{ width: '30%' }}>
	  <Image  src="\Images\WSSL FINAL LOGO 3_L2.jpg" style={{ width:'22rem', height:"auto" }} className="img-fluid m-2" />
	
	<br/>
	<a href="./Images/WSSL_Brochure 3.pdf" target="_blank"><p style={{background:"#3f83b6", color:"white",textDecoration:"None"}} className="text-center py-2 rounded">  Company Profile <i class="fa-solid fa-download"></i></p></a>
	
		</div>
		</div>
		<br/>
</Container>

		<div className='text-center' style={{backgroundImage:`url("./Images/background/contact-home.jpg")`, height:"100%",width:"100%",backgroundSize:"cover"}}>

		
<Container className="my-4" >

		<h1 className=" text-uppercase text-center " style={{backgroundColor:"#4aa489", color:"white"}} >
        Tell Us What Are You Looking For ?
      </h1>
      <Container>
        <form action="https://formspree.io/f/xjvnravn" method="POST" className="col-7 container text-center" target="_blank">
          <div className="form-group">
        
            <input type="text" name="name" className="form-control mb-4 mt-5" placeholder="Name" />
          </div>
          <div className="form-group">
            
            <input type="email" name="email" className="form-control mb-4" placeholder="Email"/>
          </div>
		  <div className="form-group">
            
		  <input type="number" name="number" className="form-control mb-4" placeholder="Mobile Number"/>
		</div>

		<div className="form-group mb-4">
				<textarea className="form-control rounded-1" name="requirement" id="Textarea2" rows="3"
					placeholder="Requirement" autocomplete="off" required></textarea>
			</div>
			<button type="submit" className=" px-5 fs-4 my-3 rounded" style={{background:"#3f83b6", color:"white",border:"none"}}>Send Enquiry</button>

        </form>

</Container>
</Container>
</div>
	

		
		
    </>
  );
};

export default Home;
